import { Icon } from "@circle-react-shared/Icon";
import type { IconType } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

import { classNames } from "@/react/helpers/twMergeWithCN";

interface PlanFeaturesListProps {
  className?: string;
  features: string[];
  iconColor?: string;
  iconSize?: number;
  iconType: IconType;
}

export const PlanFeaturesList = ({
  features,
  iconType,
  iconSize = 16,
  iconColor = "text-blue-highlight",
  className,
}: PlanFeaturesListProps) => {
  if (!features.length) return null;

  return (
    <ul className={classNames("flex list-none flex-col gap-3", className)}>
      {features.map((feature: string) => (
        <li key={feature} className="flex items-center gap-3">
          <Icon
            type={iconType}
            size={iconSize}
            color={undefined}
            className={classNames("!h-4 !w-4", iconColor)}
            useWithFillCurrentColor
            useWithStrokeCurrentColor
          />
          <Typography.BodyMd as="span" color="text-default">
            {feature}
          </Typography.BodyMd>
        </li>
      ))}
    </ul>
  );
};
